import { useState } from 'react';
import { isValidUrl } from '../utils';

interface HyperlinkInputProps {
  disabled: boolean;
  label?: string;
}

export const HyperlinkInput = ({ disabled, label }: HyperlinkInputProps) => {
  const [url, setUrl] = useState(label ?? '');

  const handleClick = () => {
    if (!url) return;

    let link = url;
    if (!/^https?:\/\//i.test(url)) {
      link = 'https://' + url;
    }

    if (isValidUrl(link)) {
      window.open(link, '_blank');
    }
  };

  return (
    <div className="space-y-1">
      <input
        type="text"
        value={url}
        disabled={disabled}
        onChange={(e) => setUrl(e.target.value)}
        onBlur={handleClick}
        className="w-full text-blue-500 underline bg-transparent border-none outline-none text-lg"
        placeholder="Enter URL"
      />
      <div className="h-[2px] bg-blue-400 w-full"></div>
    </div>
  );
};
